import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { isValidElement, Children } from 'react';
export function map(obj) {
  var _context;

  return _filterInstanceProperty(_context = _Object$keys(obj)).call(_context, function (key) {
    return obj[key];
  });
}

function hasChildren(element) {
  return /*#__PURE__*/isValidElement(element) && Boolean(element.props.children);
}

function childToString(child) {
  if (child === null || child === undefined || typeof child === 'boolean' || typeof child === 'undefined') {
    return '';
  }

  if (_JSON$stringify(child) === '{}') {
    return '';
  }

  return child.toString();
}

export function getTextFromChild(children) {
  var _context2;

  if (!(children instanceof Array) && ! /*#__PURE__*/isValidElement(children)) {
    return childToString(children);
  }

  return _reduceInstanceProperty(_context2 = Children.toArray(children)).call(_context2, function (text, child) {
    var newText = '';

    if ( /*#__PURE__*/isValidElement(child) && hasChildren(child)) {
      newText = getTextFromChild(child.props.children);
    } else if ( /*#__PURE__*/isValidElement(child) && !hasChildren(child)) {
      newText = '';
    } else {
      newText = childToString(child);
    }

    return _concatInstanceProperty(text).call(text, newText);
  }, '');
} // Create a canvas and measure the text

export function splitText(text, maxWidth) {
  var _context$measureText$2;

  var midPoint = Math.floor(text.length / 2);
  var textStart = text.substring(0, midPoint);
  var textEnd = text.substring(midPoint);
  var canvas = document.createElement('canvas');
  var context = canvas.getContext('2d');

  if (context) {
    context.font = getComputedStyle(document.body).font;
  }

  var needsTruncation = false;
  var start = textStart,
      end = textEnd;

  do {
    var _context$measureText$, _context3;

    start = start.substring(0, start.length - 1);
    end = end.substring(1);
    var truncatedTextWidth = (_context$measureText$ = context === null || context === void 0 ? void 0 : context.measureText(_concatInstanceProperty(_context3 = "".concat(start, "...")).call(_context3, end)).width) !== null && _context$measureText$ !== void 0 ? _context$measureText$ : 0; // Check for cases where the element exists but has
    // no width (e.g. display: 'none')

    needsTruncation = maxWidth > 0 && truncatedTextWidth > maxWidth && // Stop looping if there is nothing left to truncate
    start.length + end.length > 0;
  } while (needsTruncation);

  var maxTextWidth = (_context$measureText$2 = context === null || context === void 0 ? void 0 : context.measureText(text).width) !== null && _context$measureText$2 !== void 0 ? _context$measureText$2 : 0;
  return {
    start: start,
    end: end,
    maxTextWidth: maxTextWidth
  };
}